import { render, staticRenderFns } from "./MidPanel.vue?vue&type=template&id=1573c01a&"
import script from "./MidPanel.vue?vue&type=script&lang=js&"
export * from "./MidPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports